export enum AuthNextStep {
  SignIn = "sign-in",
  SignUp = "sign-up",
}

export enum AuthSessionStatus {
  NeedsProfile = "needsProfile",
  NeedsBusiness = "needsBusiness",
  Ready = "ready",
}
